/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:21
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-24 15:40:59
 * @FilePath: \ioc_base\src\modules\workShop\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [
  {
    path: "/workShop",
    name: "workShop",
    component: () => import("@src/modules/workShop/main"),
    meta: {
      // requireAuth: true,
    },
    children: [
      {
        path: "index",
        name: "workShopIndex",
        component: () => import("@src/modules/workShop/view/workShop"),
        meta: {
          // requireAuth: true,
          // routerAlive: true
        }
      }
    ]
  },
  {
    path: "/workShopManage",
    name: "workShopManage",
    component: () => import("@src/modules/workShop/view/workShopManageNew"),
    meta: {
      requireAuth: true,
      module: "workShopManage",
      routerAlive: true
    }
  }
];

export default routes;
